import { smartSchedulingEndpoint } from "../endpoints";

export async function getSmartSchedulingAvailabilities(userToken: string) {
  const response = await fetch(`${smartSchedulingEndpoint}/${userToken}/availabilities`);

  if (!response.ok) {
    return response.json();
  }

  return response.json();
}
